import { motion } from "framer-motion";
import { useContext } from "react";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { mediaSource } from "../utilities/mediautilities";
import { useTranslation } from "react-i18next"
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const AboutSchool = () => {
    const { schoolDetails } = useContext(schoolContext);
    const { t } = useTranslation();

    return (<>
        <section className="py-32 px-6 bg-accent overflow-hidden">
            <div className="common-container grid md:grid-cols-2 gap-20 items-center">
                {schoolDetails?.about_school &&
                    <motion.div
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="text-5xl font-black text-primary mb-8 relative">
                            {t(I18N_KEYS.ABOUTUSTITLE)}
                            <span className="absolute -bottom-2 left-0 w-20 h-2 bg-secondary rounded-full" />
                        </h2>
                        <p className="text-xl text-gray-600 leading-relaxed mb-6"
                            dangerouslySetInnerHTML={{
                                __html: schoolDetails?.about_school
                            }}
                        >
                        </p>
                    </motion.div>
                }

                <motion.div
                    className="relative"
                >
                    <div className="absolute -inset-4 bg-primary/10 rounded-3xl -rotate-3" />
                    <img
                        src={mediaSource(schoolDetails?.school_image?.fileUrl)}
                        className="relative rounded-3xl shadow-2xl z-10 w-full object-cover"
                        alt="Campus"
                        onError={(e) => mediaSource(e)}
                    />
                </motion.div>
            </div>
        </section>
    </>)
}

export default AboutSchool